import * as yup from 'yup';

const nameRules = /^[a-zA-ZÀ-ÿ '-]+$/;
const phoneRules = /^\+(?:[0-9] ?){6,14}[0-9](?: ?\([0-9]+\))?$/;

const msg = (lang, en, hu, de) => {
  if (lang === 'hu') return hu;
  if (lang === 'de') return de;
  return en;
};


export const basicSchema = (lang = 'en') =>
  yup.object().shape({
    firstName: yup
      .string()
      .matches(
        nameRules,
        msg(lang, 'Invalid characters', 'Érvénytelen karakterek', 'Ungültige Zeichen')
      )
      .required(msg(lang, 'First name required', 'Keresztnév kötelező', 'Vorname ist erforderlich')),
    lastName: yup
      .string()
      .matches(
        nameRules,
        msg(lang, 'Invalid characters', 'Érvénytelen karakterek', 'Ungültige Zeichen')
      )
      .required(msg(lang, 'Last name required', 'Vezetéknév kötelező', 'Nachname ist erforderlich')),
    email: yup
      .string()
      .email(msg(lang, 'Email not valid', 'Email nem érvényes', 'E-Mail ist ungültig'))
      .required(msg(lang, 'Email required', 'Email szükséges', 'E-Mail ist erforderlich')),
    phoneNumber: yup
      .string()
      .matches(
        phoneRules,
        msg(lang, 'Phone number not valid', 'Telefonszám nem érvényes', 'Telefonnummer ist ungültig')
      )
      .required(
        msg(lang, 'Phone number required', 'Telefonszám kötelező', 'Telefonnummer ist erforderlich')
      ),
    message: yup
      .string()
      .required(
        msg(lang, 'Message is required', 'Üzenet kötelező', 'Nachricht ist erforderlich')
      ),
  });

export const extendedSchema = (formType, lang = 'en') => {
  let schema = basicSchema(lang);

  if (formType === 'volunteer') {
    schema = schema.shape({
      volunteeringTypes: yup
        .array()
        .of(yup.string())
        .min(
          1,
          msg(
            lang,
            'Select one or more volunteering types',
            'Válasszon egy vagy több önkéntességi típust',
            'Wählen Sie eine oder mehrere Arten von Freiwilligenarbeit aus'
          )
        ),
    });
  }

  return schema;
};
